import { c as _c } from "react/compiler-runtime";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import PersonOutlineOutlined from "@mui/icons-material/PersonOutlineOutlined";
import { AppBar, Box, Container, IconButton, Stack, Button } from "@mui/material";
import Link from "next/link";
import { lazy, Suspense, useEffect, useState } from "react";
import config from "@/app/config";
import { useAppContext } from "@/app/contextProviders/app-context";
import { PATIENT_SERVICES_BASE_PATH } from "@/lib/constants";
import { useSchedulerActor, useSchedulerSelector } from "@/lib/hooks/useSchedulerMachine";
import { dataLayerPush } from "@/lib/utils/dataLayerHelpers";
import { Language } from "@/types/scheduler-machine";
const LanguageDialog = lazy(() => import("../LanguageDialog/LanguageDialog"));
import styles from "./Header.module.css";
function getMobileLabel(language: string): string {
  return language === "en-us" ? "EN" : "ES";
}
function getButtonLabel(language: string): string {
  return language === "en-us" ? "English" : "Español";
}
const Header = () => {
  const $ = _c(42);
  const actorRef = useSchedulerActor();
  const currentLanguage = useSchedulerSelector(_temp);
  const {
    stateCode,
    currentFacility
  } = useAppContext();
  const [origin, setOrigin] = useState("");
  const logo = config.header.logo;
  const logoMobile = config.header.logoMobile;
  const [isLanguageDialogOpen, setIsLanguageDialogOpen] = useState(false);
  let t0;
  if ($[0] !== currentFacility?.code || $[1] !== currentFacility?.name || $[2] !== stateCode) {
    t0 = () => {
      if (currentFacility?.code) {
        dataLayerPush({
          event: "facility_set",
          brand: "aspendental",
          website_selected_facility_id: currentFacility?.code,
          website_selected_facility_name: currentFacility?.name
        }, stateCode);
      }
    };
    $[0] = currentFacility?.code;
    $[1] = currentFacility?.name;
    $[2] = stateCode;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = currentFacility?.code;
  const t2 = currentFacility?.name;
  let t3;
  if ($[4] !== stateCode || $[5] !== t1 || $[6] !== t2) {
    t3 = [t1, t2, stateCode];
    $[4] = stateCode;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t0, t3);
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (globalThis.window !== undefined) {
        setOrigin(globalThis.location.origin);
      }
    };
    t5 = [];
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== actorRef) {
    t6 = language => {
      actorRef.send({
        type: "SET_LANGUAGE",
        language
      });
    };
    $[10] = actorRef;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleLanguageSelect = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Box className={styles.desktopLogo}>{logo?.url && <Link href="/" title="Aspen Logo"><img src={logo.url} alt={logo.description || "Aspen Logo"} width={180} height={36} style={{
          height: "auto"
        }} /></Link>}</Box>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box className={styles.mobileLogo}>{logoMobile?.url && <Link href="/" title="Aspen Logo"><img src={logoMobile.url} alt={logoMobile.description || "Aspen Logo"} width={150} height={36} style={{
          height: "auto",
          paddingTop: "10px"
        }} /></Link>}</Box>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      alignItems: "center",
      gap: {
        md: 2,
        xs: 1
      }
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsLanguageDialogOpen(true);
    t11 = <LanguageOutlinedIcon className={styles.languageIcon} />;
    $[15] = t10;
    $[16] = t11;
  } else {
    t10 = $[15];
    t11 = $[16];
  }
  let t12;
  if ($[17] !== currentLanguage) {
    t12 = getButtonLabel(currentLanguage);
    $[17] = currentLanguage;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = <span className={styles.desktopLabel}>{t12}</span>;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== currentLanguage) {
    t14 = getMobileLabel(currentLanguage);
    $[21] = currentLanguage;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <span className={styles.mobileLabel}>{t14}</span>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t15) {
    t16 = <Button variant="secondary" onClick={t10}>{t11}{t13}{t15}</Button>;
    $[25] = t13;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = origin ? origin + PATIENT_SERVICES_BASE_PATH : PATIENT_SERVICES_BASE_PATH;
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <PersonOutlineOutlined />;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t17) {
    t19 = <IconButton color="primary" size="small" href={t17} title="Patient Portal" aria-label="Patient Portal">{t18}</IconButton>;
    $[29] = t17;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t16 || $[32] !== t19) {
    t20 = <Container maxWidth={false} className={styles.container}>{t7}{t8}<Stack direction="row" sx={t9}>{t16}{t19}</Stack></Container>;
    $[31] = t16;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => setIsLanguageDialogOpen(false);
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== currentLanguage || $[36] !== handleLanguageSelect || $[37] !== isLanguageDialogOpen) {
    t22 = <Suspense fallback={null}><LanguageDialog open={isLanguageDialogOpen} onClose={t21} currentLanguage={currentLanguage} onLanguageSelect={handleLanguageSelect} /></Suspense>;
    $[35] = currentLanguage;
    $[36] = handleLanguageSelect;
    $[37] = isLanguageDialogOpen;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t20 || $[40] !== t22) {
    t23 = <AppBar position="static" className={styles.headerAppBar}>{t20}{t22}</AppBar>;
    $[39] = t20;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  return t23;
};
export default Header;
function _temp(s) {
  return s.context.currentLanguage;
}